<template>
  <template v-for="(value,index) in formArray.formItems" :key="index">
    <a-form-item :label="value.label" :help="value.help">
      <!-- 普通表单 -->
      <template v-if="value.stamp=='input'">
        <a-input v-model:value="modelRef[value.key][value.name]" :type="value.type" :help="value.help" :maxlength="value.maxlength"  style="width:300px"/>
      </template>
      <!-- 单选框 -->
      <template v-if="value.stamp=='radio'">
        <a-radio-group :options="value.options" v-model:value="modelRef[value.key][value.name]" />
      </template>
      <!-- 多选框 -->
      <template v-if="value.stamp=='checkbox'">
        <a-checkbox-group :options="value.options" v-model:value="modelRef[value.key][value.name]" />
      </template>
      <template v-if="value.stamp=='fieldsKey'">
        <a-button type="link" @click="chooseFields(value)">{{ fieldsTitle }}</a-button>
      </template>
      <!-- 选择框 -->
      <template v-if="value.stamp=='select'">
        <a-select v-model:value="modelRef[value.key][value.name]" :style="{width:'270px'}" placeholder="请选择">
          <a-select-option v-for='item in value.options' :key='item.value' :value="item.value">{{item.label}}
          </a-select-option>
        </a-select>
      </template>
       <!-- 模板关联 -->
      <template v-if="value.stamp=='query'">
        <a-input-search v-model:value="modelRef[value.key][value.name]" @search="childrenIndex='query_'+index;fwVisible=true" style="width:90%" readonly placeholder="默认模板">
                <template #enterButton>
                  <a-button type="primary">
                    选择
                  </a-button>
                </template>
        </a-input-search>
      </template>
      <!-- 导航 -->
      <template v-if="value.stamp=='navImage'">
        <div v-for="(items,indexs) in modelRef.data" :key="indexs" class="imagesContent">
          <a-form-item label="图标" :label-col="{span:4}" :wrapper-col="{span:17}">
            <!-- {{modelRef.data}} -->
           <img v-if="items.imgUrl" :src="items.imgUrl.indexOf('http')!=-1?items.imgUrl:navDefIconMap[items.key]" alt="">
            <!-- <span class="fontTrace " :class="'icon-'+items.imgUrl" style="color:rgb(79, 161, 252);font-size:30px" v-if="items.imgUrl"></span> -->
            <span v-else>暂无选择模块</span>
            <!-- <material :groupType='1' :image="items['imgUrl']" :max="1" v-on:handlechoose="(data)=>{items['imgUrl']=info.picdomain+data}" v-on:handledel="items['imgUrl']=''" /> -->
           <!-- <a-button type="link" @click="setDef(items)">恢复默认图</a-button> -->
          </a-form-item>
          <a-form-item label="名称" :label-col="{span:4}" :wrapper-col="{span:17}">
            <a-input v-model:value="items['name']">
            </a-input>
          </a-form-item>
          <a-form-item label="链接地址" :label-col="{span:4}" :wrapper-col="{span:17}">
            <a-input-search v-model:value="items['linkUrl']" @search="childrenIndex=indexs;linkVisible=true" readonly>
              <template #enterButton>
                <a-button type="primary">
                  选择
                </a-button>
              </template>
            </a-input-search>
          </a-form-item>
          <CloseOutlined class="images_del" @click="delImagesData(indexs)" />
          <!-- 菜单拓展 -->
          <template v-if="items.key=='public'||items.key=='video'||items.key=='group'">
            <a-form-item :label="items.key=='group'||items.key=='public'?'背景图':'显示图片'" :label-col="{span:4}" :wrapper-col="{span:17}" help="建议尺寸1257*1588像素">
              <material :groupType='1' :image="items['config'].image" :max="1" v-on:handlechoose="(data)=>{items['config'].image=info.picdomain+data}" v-on:handledel="items['config'].image=''" />
            </a-form-item>
          </template>
          <template v-if="items.key=='group'">
            <a-form-item label="群二维码" :label-col="{span:4}" :wrapper-col="{span:17}">
              <material :groupType='1' :image="items['config'].code" :max="1" v-on:handlechoose="(data)=>{items['config'].code=info.picdomain+data}" v-on:handledel="items['config'].code=''" />
            </a-form-item>
          </template>
          <template v-if="items.key=='group'">
            <a-form-item label="长按识别Logo" :label-col="{span:4}" :wrapper-col="{span:17}">
              <material :groupType='1' :image="items['config'].icon" :max="1" v-on:handlechoose="(data)=>{items['config'].icon=info.picdomain+data}" v-on:handledel="items['config'].icon=''" />
            </a-form-item>
          </template>
          <template v-if="items.key=='group'">
            <a-form-item label="客服微信号" :label-col="{span:4}" :wrapper-col="{span:17}">
              <a-input v-model:value="items['config'].wechat" />
            </a-form-item>
          </template>
          <template v-if="items.key=='video'">
            <a-form-item label="视频" :label-col="{span:4}" :wrapper-col="{span:17}">
              <material :groupType='2' :image="items['config'].video_cover" :max="1" v-on:handlechoose="(data)=>{
                    items['config'].video_source=data.file_name;items['config'].video_cover=data.video_image_name}" v-on:handledel="items['config'].video_source='';items['config'].video_cover=''" />
            </a-form-item>
          </template>
          <template v-if="items.key=='examine'">
            <a-form-item label="图片" :label-col="{span:4}" :wrapper-col="{span:20}">
              <material :groupType='1' :imageList="items.config.data" :max="6" v-on:handlechoose="(data)=>{items.config['data']=items.config.data?items.config.data.concat(data):data}" v-on:handledel="(data)=>{items.config.data=data}" />
            </a-form-item>
          </template>
          <template v-if="items.key=='query'">
            <a-form-item label="关联模板" :label-col="{span:4}" :wrapper-col="{span:17}">
              <a-input-search v-model:value="items.antis_fake_tem_title" @search="childrenIndex=indexs;fwVisible=true" readonly placeholder="默认模板">
                <template #enterButton>
                  <a-button type="primary">
                    选择
                  </a-button>
                </template>
              </a-input-search>
            </a-form-item>
          </template>
          <!-- key=='examine' -->
          <!-- key=='group' -->
          <!-- key=='video' -->
          <!-- key=='public' -->
          <!-- key=='center' -->
          <!-- key=='store' -->
          <!-- key=='query' -->
        </div>
        <!-- 菜单拓展结束 -->
        <a-button type="primary" @click="addNavImagesData(index)" v-if="modelRef.data.length<4">
          添加一个
        </a-button>
      </template>
      <!-- 图片上传 -->
      <template v-if="value.stamp=='image'">
        <div v-for="(items,indexs) in modelRef.data" :key="indexs" class="imagesContent">
          <a-form-item label="图片" :label-col="{span:4}" :wrapper-col="{span:17}">
            <material :groupType='1' :image="items['imgUrl']" :max="1" v-on:handlechoose="(data)=>{items['imgUrl']=info.picdomain+data}" v-on:handledel="items['imgUrl']=''" />
          
          </a-form-item>
          <a-form-item label="链接地址" :label-col="{span:4}" :wrapper-col="{span:17}">
            <a-input-search v-model:value="items['linkUrl']" @search="childrenIndex=indexs;linkVisible=true" readonly>
              <template #enterButton>
                <a-button type="primary">
                  选择
                </a-button>
              </template>
            </a-input-search>
          </a-form-item>
          <CloseOutlined class="images_del" @click="delImagesData(indexs)" />
        </div>
        <a-button type="primary" @click="addImagesData(index)">
          添加一个
        </a-button>
      </template>
      <!-- 单图片上传 -->
      <template v-if="value.stamp=='singleImage'">
        <material :groupType='1' :image="modelRef[value.key][value.name]" :max="1" v-on:handlechoose="(data)=>{modelRef[value.key][value.name]=info.picdomain+data}" v-on:handledel="modelRef[value.key][value.name]=''" />
         <span v-if="value.defaultValue" @click="modelRef[value.key][value.name]=value.defaultValue">恢复默认</span>
      </template>
      <!-- 单视频素材 -->
      <template v-if="value.stamp=='video'">
        <material
          :groupType="2"
          :image="modelRef[value.key][value.coverName]"
          :max="1"
          v-on:handlechoose="(data)=>selectVideo(data, value)"
          v-on:handledel="clearVideo(value)"
        />
        <div class="s_c999 m-t-5" v-if="modelRef[value.key][value.name]">已选择视频素材</div>
      </template>
      <!-- 滑动 -->
      <template v-if="value.stamp=='slider'">
        <a-slider
          :min="value.min === undefined ? 0 : value.min"
          :max="value.max === undefined ? 100 : value.max"
          :tip-formatter="(value)=>value+'px'"
          v-model:value="modelRef[value.key][value.name]"
          style="width:300px"
        />
      </template>
    </a-form-item>
  </template>

  <!-- 溯源信息 / 企业信息字段管理 -->
  <a-modal
    :title="fieldsTitle"
    centered
    v-model:visible="fieldsVisible"
    :width="1200"
    :footer="null"
    destroy-on-close
  >
    <fieldsManage
      v-if="fieldsVisible"
      :is_sys="isEnterprise ? 2 : 1"
      :fields="isEnterprise ? enterpriseFields : traceFields"
      :show-key="modelRef[fieldsData.key][fieldsData.name] || []"
      :selected-fields="selectedFields"
      @change="updateFields"
    />
  </a-modal>

  <!-- 链接选择 -->
  <a-modal :keyboard="false" title="链接" centered v-model:visible="linkVisible" @ok="handleOk" style="width:1200px" :width="1200">
    <untilSelect v-on:success="selecLink" />
  </a-modal>

  <!-- 关联模板 -->
  <a-modal :keyboard="false" title="关联模板" centered v-model:visible="fwVisible" @ok="fwVisible=false" style="width:1200px" :width="1200">
    <fwAudiSelect v-on:select="selecFwAudi" />
  </a-modal>

</template>

<script>
import { computed, onMounted, ref, watch, watchEffect } from "@vue/runtime-core";
import forms from "../form";
import { message } from "ant-design-vue";
import store from "@/store";
import untilSelect from "../components/untilSelect/index";
import { CloseOutlined } from "@ant-design/icons-vue";
import config from '@/config'
import fieldsManage from '@/components/fieldsManage/index.vue'
import { traceFields, enterpriseFields } from '../traceFields'
// 导航图标映射
const navDefIconMap={
  examine:config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/report.png',//检验报告
  group:config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/group.png',//粉丝社群
  video:config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/video.png',//宣传视频
  public: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/report.png',//公众号
  store: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/store_icon.png',//'云店'
  query: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/query_icon.png',//防伪查询'
  center: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/center_icon.png',//'会员中心',
}


export default {
  props: {
    options: Object,
    key: Number,
    moduleIndex:Number,
    antis_fake_tem_data:{
      type:Array ||null,
      default(){
        // 溯源查询的 防伪信息的数据
        return []
      }
    }
  },
  components: { CloseOutlined, untilSelect, fieldsManage},
  setup(props, { emit }) {
    const fieldsVisible = ref(false);
    const fieldsData = ref({});
    const selectedFields = ref([]);
    const chooseFields = (value) => {
      fieldsData.value = value;
      const params = modelRef.value[value.key];
      selectedFields.value = JSON.parse(JSON.stringify([
        ...(modelRef.value.data || []),
        ...(params.fieldList || []),
        ...(params.sysFieldList || []),
      ]));
      fieldsVisible.value = true;
    };
    const updateFields = ({ keys, rows }) => {
      const params = modelRef.value[fieldsData.value.key];
      params[fieldsData.value.name] = keys;
      // 与源项目保持相同的存储结构，便于扫码端读取自定义名称、内容与排序。
      params.sysFieldList = rows;
      params.fieldKey = [...keys];
      params.fieldList = JSON.parse(JSON.stringify(rows));
      params.data = JSON.parse(JSON.stringify(rows));
    };
    watch(() => [props.options, props.moduleIndex], () => { fieldsVisible.value = false; });
    const linkVisible = ref(false);
    const formArray = ref({ formItems: [] });
    const isEnterprise = computed(() => formArray.value.type === 'enterprise');
    const fieldsTitle = computed(() => (isEnterprise.value ? '企业信息' : '溯源信息') + '字段管理');
    const modelRef = ref({});
    watchEffect(
      () => {
        var options = props.options;
        modelRef.value = JSON.parse(JSON.stringify(options));
        if (options.type != "layout") {
          formArray.value = forms.find((v) => v.type == options.type) || {
            formItems: [],
          };
        }
      },
      { deep: true }
    );
    // 监听表单数据变化
    // watch(modelRef,(newValue)=>{
    //       console.log(newValue)
    // })
    watch(
      () => modelRef.value,
      (newValue) => {
        emit("update", { ...newValue });
      },
      { deep: true }
    );
    const childrenIndex = ref(0);
    // 地址选择完成
    const selecLink = (data) => {
      modelRef.value.data[childrenIndex.value].linkUrl = data.link;
      modelRef.value.data[childrenIndex.value].key = data.key;
      modelRef.value.data[childrenIndex.value].name = data.name;
      modelRef.value.data[childrenIndex.value].imgUrl = data.icon;
      modelRef.value.data[childrenIndex.value].config={}
      linkVisible.value = false;
    };
    // 删除轮播图片数据
    const delImagesData = (index) => {
      if (modelRef.value.data.length == 1) {
        message.error("至少要存在一个元素");
      } else {
        modelRef.value.data.splice(index, 1);
      }
    };
    // 追加图片数据
    const addImagesData = (index) => {
      modelRef.value.data.push({ imgUrl: "", linkUrl: "" });
    };
    // 追加菜单
    const addNavImagesData = () => {
      modelRef.value.data.push({
        imgUrl: "",
        linkUrl: "",
        key: "",
        name: "",
        config: {},
      });
    };
    const selectVideo = (data, value) => {
      modelRef.value[value.key][value.name] = data.file_name;
      modelRef.value[value.key][value.coverName] = data.video_image_name || '';
    };
    const clearVideo = (value) => {
      modelRef.value[value.key][value.name] = '';
      modelRef.value[value.key][value.coverName] = '';
    };

    // 关联模板
    const antis_fake_tem_data = ref([]); //用于储存关联模板的集合
    onMounted(()=>{
      if(props.antis_fake_tem_data){
        antis_fake_tem_data.value=props.antis_fake_tem_data
      }
    })
    const fwVisible = ref(false);
    const selecFwAudi = (data) => {
      console.log(childrenIndex.value,'-2',data)
      if(String(childrenIndex.value).indexOf('query')!=-1){
        modelRef.value['params']=modelRef.value['params']||{}
        modelRef.value['params'].antis_fake_tem_id=data.id
        modelRef.value['params'].antis_fake_tem_title=data.name
      }else{
         var origin= modelRef.value.data[childrenIndex.value].antis_fake_tem_id
          modelRef.value.data[childrenIndex.value].antis_fake_tem_id = data.id;
          modelRef.value.data[childrenIndex.value].antis_fake_tem_title =data.name;
          console.log(origin,'----------')
          emit('upadteAntisdata',{
            origin:origin,//原始ID
            moduleIndex:props.moduleIndex,//父级
            index:childrenIndex.value,//子级索引
            antis_fake_tem_data:data
          })
      }
 
      fwVisible.value = false;

    };
    // 导航图标恢复默认图
    const setDef=(data)=>{
      console.log(data)
      data.imgUrl=navDefIconMap[data.key]
    }
    return {
      fieldsVisible,
      fieldsData,
      selectedFields,
      chooseFields,
      updateFields,
      traceFields,
      enterpriseFields,
      isEnterprise,
      fieldsTitle,
      formArray,
      modelRef,
      selecLink,
      linkVisible,
      childrenIndex,
      delImagesData,
      info: store.state.user.info,
      addImagesData,
      addNavImagesData,
      selectVideo,
      clearVideo,
      fwVisible,
      selecFwAudi,
      setDef
    };
  },
};
</script>
<style lang="less" scoped>
.imagesContent {
  padding: 20px;
  background: #f7fafc;
  position: relative;
  border-radius: 3px;
  cursor: move;
  min-height: 240px;
  margin-bottom: 20px;

  .images_del {
    position: absolute;
    right: 10px;
    top: 0;
    cursor: pointer;
  }
}
</style>
